"use client";

import { displayValue } from "@/components/OtherBetsDropdown";
import { trendClass } from "./BoltTrendUtils";

export default function BoltThreeColSection({ title, items, width = "ods-50" }) {
  return (
    <div className={`kbv-v26-odt-item ${width}`}>
      <div className="kbv-v26-odt-title">
        <span>{title}</span>
        <span></span>
      </div>
      <div className="kbv-v26-odt-odds-list">
        {items.map((item, i) => (
          <div key={i}>
            <div className="kbv-v26-odt-label">{item.label}</div>
            <div className={`kbv-v26-odt-odds ${trendClass(item.trend)}`}>
              {displayValue(item.value)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
